import React, { memo, useCallback } from 'react';
import { useToggle } from 'react-use';
import { Button } from '../../../button';
import { SaveModal } from './save-modal';
export const SearchSave = memo(function SearchSave({ onSave, isSaveAvailable }) {
    const [isOpenSaveModal, toggleSaveModal] = useToggle(false);
    const openSaveModal = useCallback(() => toggleSaveModal(true), [toggleSaveModal]);
    const closeSaveModal = useCallback(() => toggleSaveModal(false), [toggleSaveModal]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "outline", text: "Save", onClick: () => openSaveModal(), disabled: !isSaveAvailable }),
        React.createElement(SaveModal, { isOpen: isOpenSaveModal, closeModal: closeSaveModal, onSave: onSave })));
});
